<template>
  <div class="rb-media rb-wrap">
    <div class="rb-content">
      <media-on-hand-video
        :active="mode === 'onHandVideos'"
        :videos="onHandVideos"
        ref="elOnHandVideos"
        v-if="onHandVideos.length"
      />
      <media-images
        :active="mode === 'images'"
        :images="mediaImages"
        ref="elImages"
      />
      <media-videos
        :active="mode === 'videos'"
        :videos="mediaVideos"
        ref="elVideos"
        v-if="mediaVideos.length"
      />
    </div>
    <div class="rb-foot">
      <div class="rb-controls">
        <button
          aria-label="Show Images"
          :class="['rb-btn-gallery', { 'rb-active': mode === 'images' }]"
          @click.prevent="setMode($event, 'images')"
          id="btn-gallery-images"
        >
          <icon-images />
          <span>Images</span>
        </button>
        <button
          aria-label="Show Videos"
          :class="['rb-btn-gallery', { 'rb-active': mode === 'videos' }]"
          @click.prevent="setMode($event, 'videos')"
          v-if="videoEnabled && mediaVideos.length"
          id="btn-gallery-videos"
        >
          <icon-video />
          <span>Video</span>
        </button>
        <button
          aria-label="Show On Hand Videos"
          :class="['rb-btn-gallery', { 'rb-active': mode === 'onHandVideos' }]"
          @click.prevent="setMode($event, 'onHandVideos')"
          v-if="onHandVideoEnabled && onHandVideos.length"
          id="btn-gallery-3d"
        >
          <icon-video />
          <span>On-Hand</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * Displays ERB gallery. Including Images, 3D models and videos
 *
 * @props
 * apiModelViewer: Object
 * availableModels: Object
 *
 * @implements
 * CommMixin
 * ChildMixin
 * TrackMixin
 *
 * @listens
 * rb-selected-options-updated
 * rb-step-display-update
 * rb-disable-video
 * rb-ensable-video
 */
import MediaImages from "@/components/MediaImages";
import MediaVideos from "@/components/MediaVideos";
import IconImages from "@/components/icons/IconImages";
import IconVideo from "@/components/icons/IconVideo";
import ChildMixin from "@/mixins/ChildMixin";
import CommMixin from "@/mixins/CommMixin";
import TrackMixin from "@/mixins/TrackMixin";
import MediaOnHandVideo from './MediaOnHandVideo.vue';
export default {
  mixins: [CommMixin, ChildMixin, TrackMixin],
  components: {
    MediaImages,
    MediaVideos,
    MediaOnHandVideo,
    IconImages,
    IconVideo,
  },
  props: {
    apiModelViewer: {
      type: Object,
      default: () => ({ baseJsonUrl: "", iframeUrl: "" }),
    },
    availableModels: {
      type: Array,
      default: () => [],
    },
  },
  data: function () {
    return {
      mode: "videos",
      modelAvailable: false,
      videoEnabled: true,
      onHandVideoEnabled: true,
      // optionsBuffer: []
    };
  },
  mounted: function () {
    if (this.mode === "images") {
      this.$refs.elImages.refresh();
    }
    if (this.mode === "videos" && this.mediaVideos?.length) {
      this.$refs.elVideos.refresh();
    }
    if (this.mode === "onHandVideos" && this.onHandVideos?.length) {
      this.$refs.elOnHandVideos.refresh();
    }
    this.subscribe(
      "rb-selected-options-updated",
      this.onSelectedOptionsUpdated
    );
    this.subscribe("rb-step-display-update", this.onStepDisplayUpdate);
    this.subscribe("rb-available-models", this.onAvailableModels);
    this.subscribe("rb-disable-video", this.onDisableVideo);
    this.subscribe("rb-enable-video", this.onEnableVideo);
    this.subscribe("rb-disable-on-hand-video", this.onDisableOnHandVideo);
    this.subscribe("rb-enable-on-hand-video", this.onEnableOnHandVideo);
    if(this?.data?.defaultOnHand && this.onHandVideos?.length) {
      this.setMode(null, "onHandVideos");
    } else if(this.videoEnabled && this.mediaVideos?.length) {
      this.setMode(null, "videos");
    } else {
      this.setMode(null, "images");
    }
  },
  methods: {
    onEnableVideo: function () {
      this.videoEnabled = true;
    },
    onDisableVideo: function () {
      this.videoEnabled = false;
      if(!this.onHandVideoEnabled) {
        this.setMode(null, "images");
      }
      /*if (this.enable3d) {
        this.setMode(null, "3d");
      } else {
        this.setMode(null, "images");
      }*/
    },
    onEnableOnHandVideo: function () {
      this.onHandVideoEnabled = true;
    },
    onDisableOnHandVideo: function () {
      this.onHandVideoEnabled = false;
      if(this.videoEnabled && this.mediaVideos?.length) {
        this.setMode(null, "videos");
      } else {
        this.setMode(null, "images");
      }
    },
    onStepDisplayUpdate: function (step) {
      if (step.id === "diamond") {
        if (this.enable3d) {
          this.setMode(null, "3d");
        }
      }
    },
    onAvailableModels: function (data) {
      this.$nextTick(() => {
        this.onSelectedOptionsUpdated(data);
      });
    },
    onSelectedOptionsUpdated: function (data) {
      this.checkMode(data);
    },
    checkMode: function (data) {
      var shape = this.getSelectedOptionValue(data, "shape", "");
      shape = shape === "round-brilliant" ? "round" : shape;
      this.modelAvailable =
        this.availableModels.find((av) => av.name.toLowerCase() === shape)
          ?.available || false;

      // if (
      //   (!this.modelAvailable && this.availableModels?.length) ||
      //   this.mediaVideos?.length <= 0
      // ) {
      //   // console.log("setting images", this.mode);
      //   if (this.mode !== "videos" || this.mediaVideos.length === 0)
      //     this.setMode(null, "images");
      // }

      // Force display by metafield
      if (
        this.data.product.metafields_custom &&
        this.data.product.metafields_custom.gallery_default
      ) {
        this.setMode(null, this.data.product.metafields_custom.gallery_default);
      }
    },
    getSelectedOptionValue(data, id, defaultValue) {
      var selected = data.selectedOptions.find(
        (selectedOption) => selectedOption.step.id === id
      );
      var returnVal = defaultValue;
      if (selected) {
        returnVal = data.mappings.viewer3d[id][selected.choice.id];
      }
      return returnVal;
    },
    setMode: function (event, mode) {
      this.mode = mode;
      if (this.$refs.elVideo) this.$refs.elVideo.pause();
      if (this.mode === "images") {
        this.$refs.elImages.refresh();
      }
      if (this.mode === "videos") {
        this.$refs.elVideos.refresh();
        this.$nextTick(() => {
          this.$refs.elVideos.play();
        });
      }
      if (this.mode === "onHandVideos") {
        this.$refs.elOnHandVideos.refresh();
        this.$nextTick(() => {
          this.$refs.elOnHandVideos.play();
        });
      }
      this.trackEvent(
        this.formatTracking(
          event ? this.getTrackId(event) : "media-gallery",
          this.TRACK_CLICK
        ),
        event ? this.getTrackId(event) : "media-gallery"
      );
    },
  },
  computed: {
    mediaImages: function () {
      return this.data.product.media.filter(
        (media) => media.media_type !== "video"
      );
    },
    mediaVideos: function () {
      return this.data.product.media.filter(
        (media) => media.media_type === "video"
      );
    },
    onHandVideos: function () {
      return this.data.product.variants.filter(variant => {
        return variant?.metafields_custom?.on_hand_video  
      }).map(variant => {
        return {
          url: variant?.metafields_custom?.on_hand_video,
          options: variant?.options.map(option => option?.toLowerCase())
        }
      });
    },
    baseModel: function () {
      return (
        this.data.product.tags
          .find((tag) => tag.indexOf("model-") > -1)
          ?.split("-")
          ?.slice(1)
          .join("-") || ""
      );
    },
    enable3d: function () {
      return (
        this.data.enable3d &&
        !this.data.product.tags.includes("hide-3d") &&
        this.modelAvailable
      );
    },
  },
};
</script>
